import React, { Component } from "react";
import PublicProjectsApi from "../../lib/SHub.API.PublicProjects";
import {
  TextField,
  Button,
  Typography,
  LinearProgress,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Modal,
  Box,
} from "@mui/material";
import "./viewer.styles.css";
import { withRouter } from "react-router";
// import data_json from '../../lib/verisk_data'
// import DrawingUtil from '../../lib/drawingUtil'

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

class Viewer extends Component {
  constructor(props) {
    super(props);

    this.props = props;
    this.docs = [];
    this.views = {};
    this.viewer = null;
    this.viewerDiv = React.createRef();

    this.geomIsLoaded = false;
    this.allDbIds = [];
    this.allFragIds = [];
    this.instanceTree = null;

    this.state = {
      materials: ["Light Weight Concrete", "Heavy Weight Concrete", "Wood"],
      selectedMaterial: "Light Weight Concrete",
      openModal: false,

      carbonFootprint: 50,
      powerConsumption: 70,
      wallThickness: 0.57,
      ventilation: 2,
      camera: 0,
      MaterialState: "Light Weight Concrete",
    };
  }

  componentWillUnmount() {
    // console.log(" Forge Viewer will unmount !!")
    if (this.viewer) {
      // I added this to handle some specific cases
      if (this.viewer.impl.selector) {
        // console.log("tearing down forge viewer ....")
        this.viewer.finish();
        this.viewer = null;
        this.Autodesk.Viewing.shutdown();
      }
    }
  }

  getBrowserSize() {
    var w, h;

    if (
      typeof document.documentElement !== "undefined" &&
      typeof document.documentElement.clientWidth !== "undefined" &&
      document.documentElement.clientWidth !== 0
    ) {
      w = document.documentElement.clientWidth; //IE
      h = document.documentElement.clientHeight;
    } else {
      w = document.body.clientWidth; //IE
      h = document.body.clientHeight;
    }
    return { width: w, height: h };
  }

  getForgeToken() {
    return new Promise(function (resolve, reject) {
      let ppApi = new PublicProjectsApi();
      ppApi
        .Authenticate()
        .then((response) => {
          if (response.ok) {
            response.json().then((json) => {
              console.log(json);
              resolve({
                access_token: json.access_token,
                expires_in: 1800,
                token_type: "Bearer",
              });
            });
          }
        })
        .catch(function (err) {
          console.log(err);
          reject(err);
        });
    });
  }

  handleTokenRequested(onAccessToken) {
    // console.log('Token requested by the viewer.');

    if (onAccessToken) {
      this.getForgeToken().then(function (data) {
        try {
          // console.log("forge token : ", data)
          if (data) onAccessToken(data.access_token, 1800);
        } catch (ex) {
          console.log(ex);
        }
      });
    }
  }

  onDocumentLoadSuccess(viewerDocument) {
    console.log("viewerDocument : ", viewerDocument);
    this.root = viewerDocument.getRoot();
    var defaultModel = this.root.getDefaultGeometry();
    this.viewer.loadDocumentNode(viewerDocument, defaultModel);

    this.viewer.addEventListener(
      this.Autodesk.Viewing.GEOMETRY_LOADED_EVENT,
      () => {
        this.geomIsLoaded = true;
        console.log("this.root : ", this.root);
        this.setState({
          camera: this.viewer.getCamera().position.x
        })
        console.log("Camera loca Z", this.state.camera)

        // this.viewer.hide(this.root.id)
        // this.viewer.setGhosting(false);
        // this.viewer.loadExtension('Viewing.Extension.Transform');

        // this.instanceTree = this.viewer.impl.model.getData().instanceTree;
        // let allDbIdsStr = Object.keys(this.instanceTree.nodeAccess.dbIdToIndex);
        // this.allDbIds = allDbIdsStr.map(function (id) { return parseInt(id) })

        // console.log("this.allDbIds : ", this.allDbIds)

        // for (var i = 0; i < this.allDbIds.length; i++) {
        //     var dbid = this.allDbIds[i];
        //     try {
        //         this.instanceTree.enumNodeFragments(dbid, (fragId) => {
        //             this.allFragIds.push(fragId)
        //         })
        //     } catch (error) {
        //         console.error(error);
        //     }
        // }

        // this.allWallMeshes = this.getAllWallMeshes(this.allFragIds)
        this.viewer.addEventListener(this.Autodesk.Viewing.CAMERA_CHANGE_EVENT, (evt) => {
          console.log("CAMERA_CHANGE_EVENT : ", evt.camera.position)

          if (evt.camera.position.x > this.state.camera) {
            this.setState({
              carbonFootprint: this.state.carbonFootprint + 0.01,
              powerConsumption: this.state.powerConsumption + 0.05,
              camera: evt.camera.position.x
            })
          }
          else {
            this.setState({
              carbonFootprint: this.state.carbonFootprint - 0.01,
              powerConsumption: this.state.powerConsumption - 0.05,
              camera: evt.camera.position.x
            })
          }


        })
        this.viewer.loadExtension("CameraRotation");
        this.viewer.loadExtension("TransformationExtension")
      }
    );

    //this.viewer.loadExtension('Autodesk.BIM360.RollCamera')
    // this.viewer.loadExtension("Autodesk.ADN.Viewing.Extension.TransformTool")
  }

  onDocumentLoadFailure() {
    console.error("Failed fetching Forge manifest");
  }

  handleViewerInit() {
    var htmlDiv = document.getElementById("forgeViewer");
    var config3d = { extensions: ["CameraRotation"] };
    this.viewer = new this.Autodesk.Viewing.Private.GuiViewer3D(
      htmlDiv,
      config3d
    );
    var startedCode = this.viewer.start();
    if (startedCode > 0) {
      console.error("Failed to create a Viewer: WebGL not supported.");
      return;
    }
    console.log("Initialization complete, loading a model next...");

    // this.Autodesk.Viewing.Document.load("urn:" + btoa("urn:adsk.objects:os.object:cctechfluidvolumebucket/ml-mesh-seg_3LrZTq.stl"), this.onDocumentLoadSuccess.bind(this),
    //     this.onDocumentLoadFailure.bind(this));

    this.Autodesk.Viewing.Document.load(
      "urn:dXJuOmFkc2sub2JqZWN0czpvcy5vYmplY3Q6cHJvamVjdC13aG8tc2F2ZXMtdGhlLWRheS8zRF9CdWlsZGluZ19TaW5nbGUlMjAucnZ0",
      this.onDocumentLoadSuccess.bind(this),
      this.onDocumentLoadFailure.bind(this)
    );
  }

  componentDidMount() {
    this.Autodesk = window.Autodesk;
    let options = {
      env: "AutodeskProduction",
      getAccessToken: this.handleTokenRequested.bind(this),
    };

    this.Autodesk.Viewing.Initializer(
      options,
      this.handleViewerInit.bind(this)
    );
  }

  toggleChange = (event) => {
    this.setState({
      isChecked: this.state.isChecked,
    });
  };

  handleChange = (event) => {
    {
      let carbonFootprintValue, powerConsumptionValue;
      if (event.target.value === "Light Weight Concrete") {
        carbonFootprintValue = 50;
        powerConsumptionValue = 70;
      } else if (event.target.value === "Heavy Weight Concrete") {
        carbonFootprintValue = 42;
        powerConsumptionValue = 60;
      } else if (event.target.value === "Wood") {
        carbonFootprintValue = 30;
        powerConsumptionValue = 50;
      }

      this.setState({
        carbonFootprint: carbonFootprintValue,
        powerConsumption: powerConsumptionValue,
      });
    }
    this.setState({
      selectedMaterial: event.target.value,
    });
  };

  tinthandler = (e) => {
    const checked = e.target.checked;
    if (checked) {
      //checked
      this.setState({
        carbonFootprint: this.state.carbonFootprint * 0.6,
        powerConsumption: this.state.powerConsumption * 0.8,
      });
    } else {
      //unchecked
      this.setState({
        carbonFootprint: this.state.carbonFootprint * 1.6,
        powerConsumption: this.state.powerConsumption * 1.25,
      });
    }
  };

  gameSubmit = (evt) => {
    console.log("game submission : ", evt);
    this.setState({
      openModal: true,
    });
  };

  handleModalClose = () => {
    let { history } = this.props;
    this.setState({
      openModal: false,
    });
    history.push("/home");
  };

  // getAllFragBoxes = (fragIds) => {

  //     //fragments list array
  //     var fragList = this.viewer.model.getFragmentList();
  //     const fragbBox = new window.ThreeJSObject.Box3()
  //     const AllBBoxes = []

  //     fragIds.forEach(function (fragId) {
  //         fragList.getWorldBounds(fragId, fragbBox)
  //         AllBBoxes.push(fragbBox)
  //     })

  //     return AllBBoxes
  // }

  // getAllWallMeshes = (fragIds) => {
  //     let allWallMeshes = []

  //     fragIds.forEach((fragId) => {
  //         allWallMeshes.push(this.viewer.impl.getRenderProxy(this.viewer.impl.model, fragId, null, null, null))
  //     })

  //     return allWallMeshes
  // }

  // getBoundingBox = (model, dbid) => {
  //     const tree = model.getInstanceTree();
  //     const frags = model.getFragmentList();
  //     let bounds = new window.ThreeJSObject.Box3();
  //     tree.enumNodeFragments(dbid, (fragid) => {
  //         let fragmentBounds = new window.ThreeJSObject.Box3();
  //         frags.getWorldBounds(fragid, fragmentBounds);
  //         bounds.union(fragmentBounds);
  //     }, true);
  //     return bounds;
  // }

  // getAllIntersections = () => {
  //     if (this.geomIsLoaded) {
  //         console.log("Getting all intersections")
  //         let cameraPosition = this.viewer.getCamera().position
  //         let modelBbox = this.viewer.impl.model.getBoundingBox()
  //         // let modelBbox_center = modelBbox.center
  //         // let modelBbox_diagonalDist = modelBbox.max.distanceTo(modelBbox.min)

  //         let allIntersectionsFoundDbIds = []
  //         let allIntersectionsFound = []

  //         var fragList = this.viewer.impl.model.getFragmentList();

  //         for (let i = 0; i < 100; i++) {
  //             let dbidBbox = this.getBoundingBox(this.viewer.impl.model, this.allDbIds[i])
  //             // for (let i = 0; i < this.allFragIds.length; i++) {
  //             //     const fragbBox = new window.ThreeJSObject.Box3()
  //             //     fragList.getWorldBounds(this.allFragIds[i], fragbBox)
  //             // console.log("dbidBbox : ", dbidBbox)

  //             let bBoxCenter = dbidBbox.center
  //             // let bBoxCenter = fragbBox.center

  //             // let vray = new window.ThreeJSObject.Vector3(bBoxCenter.x - cameraPosition.x, bBoxCenter.y - cameraPosition.y, bBoxCenter.z - cameraPosition.z)
  //             // // // console.log("vray : ", vray)
  //             // let ray = new window.ThreeJSObject.Raycaster(cameraPosition, vray, 0, 10000)
  //             // let intersectResults = ray.intersectObjects(this.allWallMeshes, true)

  //             // if (intersectResults.length) {
  //             //     allIntersectionsFound.push(intersectResults)
  //             // }
  //             let intersections = this.viewer.impl.hitTest(cameraPosition, bBoxCenter)

  //             // let intersections = this.viewer.impl.castRayViewport(ray, false)
  //             // console.log("intersections: ", intersections)

  //             // console.log("intersections : ", intersections)
  //             if (!allIntersectionsFoundDbIds.includes(intersections.dbId)) {
  //                 allIntersectionsFoundDbIds.push(intersections.dbId)
  //                 allIntersectionsFound.push({
  //                     dbId: intersections.dbId,
  //                     fragId: intersections.fragId
  //                 })
  //             }

  //             // dbId: intersections.dbId
  //             // fragId: intersections.fragId
  //         }

  //         console.log("allIntersectionsFound : ", allIntersectionsFound)
  //         // this.viewer.getProperties(allDbIds[5], (data1) => {
  //         //     console.log("data1 : ", data1)
  //         // }, (err) => { console.log("Error in getProperties: ", err) })
  //     }
  // }

  render() {
    let {
      materials,
      selectedMaterial,
      openModal,
      carbonFootprint,
      powerConsumption,
    } = this.state;
    let { history } = this.props;

    return (
      <div>
        {/* <div className="intersetcsBtn">
                    <Button onClick={this.getAllIntersections}>Get Intersects</Button>
                </div> */}

        <div id="scoreDisplay" className="scoreDisplayRoot">
          <div>
            <Typography variant="h6" gutterBottom component="div">
              Information Board
            </Typography>
          </div>

          <div>
            <Typography variant="button" display="block" gutterBottom>
              Carbon Footprint (tonns of Co2)
            </Typography>
            {/* value below is in percent */}
            <LinearProgress variant="determinate" value={carbonFootprint} />
          </div>

          <div>
            <br />
            <Typography variant="button" display="block" gutterBottom>
              Power Consumption (watts)
            </Typography>
            {/* value below is in percent */}
            <LinearProgress variant="determinate" value={powerConsumption} />
          </div>

          <div>
            <br />
            <Typography variant="button" display="block" gutterBottom>
              Select Material
            </Typography>
            {materials ? (
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={selectedMaterial}
                onChange={this.handleChange}
                //  onChange={this.setchange}
                label="Age"
              >
                {materials.map((item) => {
                  return (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  );
                })}
                {/* <MenuItem value={10}>Ten</MenuItem>
                            <MenuItem value={20}>Twenty</MenuItem>
                            <MenuItem value={30}>Thirty</MenuItem> */}
              </Select>
            ) : null}
          </div>

          <div>
            <br />
            <TextField
              id="ventilationPercent"
              label="Ventilation ( % )"
              variant="standard"
              defaultValue={this.state.ventilation}
              onChange={(evt) => {
                if (evt.target.value === 2 && evt.target.value !== 0) {
                  this.setState({
                    carbonFootprint: 50,
                    powerConsumption: 70,
                  });
                } else if (evt.target.value === 5 && evt.target.value !== 0) {
                  this.setState({
                    carbonFootprint: 42,
                    powerConsumption: 60,
                  });
                } else if (evt.target.value === 8 && evt.target.value !== 0) {
                  this.setState({
                    carbonFootprint: 30,
                    powerConsumption: 50,
                  });
                } else {
                  this.setState({
                    carbonFootprint: 15,
                    powerConsumption: 20,
                  });
                }
              }}
            />
          </div>

          <div>
            <br />
            <FormControlLabel
              control={<Checkbox id="windowTint" />}
              label="Window Tint"
              labelPlacement="start"
              onClick={(e) => {
                this.tinthandler(e);
              }}
            />
          </div>

          <div>
            <TextField
              id="wallThickness"
              label="Wall Thickness ( ft )"
              variant="standard"
              defaultValue={this.state.wallThickness}
              onChange={(evt) => {
                if (evt.target.value === 0.57 && evt.target.value !== 0) {
                  this.setState({
                    carbonFootprint: 50,
                    powerConsumption: 70,
                  });
                } else if (evt.target.value === 0.89 && evt.target.value !== 0) {
                  this.setState({
                    carbonFootprint: 40,
                    powerConsumption: 60,
                  });
                } else if (evt.target.value === 0.9 && evt.target.value !== 0) {
                  this.setState({
                    carbonFootprint: 38,
                    powerConsumption: 59,
                  });
                }
              }}
            />
          </div>

          <div>
            <br />
            <Button onClick={this.gameSubmit}>Submit</Button>
          </div>
        </div>
        <div>
          <Modal
            open={openModal}
            onClose={this.handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style} className="modalStyle">
              <Typography id="modal-modal-title" variant="h6" component="h2">
                Your Score !!
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                Carbon Footprint = 0.0043 tonnes of co2
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                Power Consumption = 1406 Watts
              </Typography>
              <br />
              <Button
                onClick={() => {
                  history.push("/home");
                }}
              >
                Go Home
              </Button>
            </Box>
          </Modal>
        </div>
        <div id="forgeViewer"></div>
      </div>
    );
  }
}

export default withRouter(Viewer);
